import { Controller } from "react-hook-form";
import Select from "react-select";
import { Box, Text } from "@chakra-ui/react";
import AppColors from "../../constants/AppColors";
import { FONT_FAMILY } from "../../constants/Theme";

const SubDepartmentSelect = ({ control, subDepartmentOptions, defaultSubDepartments, setCurrentSubDepartment }) => {
  // Transform department data to fit react-select format

  return (
    <Box>
      <Text fontSize="md" fontWeight="bold" my={3} color={AppColors.secondary} fontFamily={FONT_FAMILY.openSans}>
        Sub-Department
      </Text>

      <Controller
        
        name="sub_department"
        control={control}
        defaultValue={defaultSubDepartments || []}
        render={({ field }) => (
          <Select
            {...field}
            options={subDepartmentOptions}
            isMulti // Enables multiple selections
            placeholder="Select sub-departments..."
            closeMenuOnSelect={false} // Keeps dropdown open for multiple selections
            onChange={(selectedOptions) => {
              const values = selectedOptions.map((opt) => opt.value);
              field.onChange(values);
              setCurrentSubDepartment(values);
            }}            
            value={subDepartmentOptions.filter((opt) => field.value?.includes(opt.value))}
            styles={{
              control: (provided) => ({
                ...provided,
                minHeight: "50px",
                borderRadius: "8px",
                borderColor: "#CBD5E0",
              }),
            }}
          />
        )}
      />
    </Box>
  );
};

export default SubDepartmentSelect;
